/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2022 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: native-temp-file-upload-service.ts
 *
 * Created by kyang on 2022-08-22.
 */

// This service is an implementation for TempFileUploadService.

angular.module('prism-ui.components').service('NativeTempFileUploadService', function (
    this: JS5Object,
    _: JS5Object,
    $injector: JS5Object,
    $q: JS5Object,
    EndPointService: JS5Object,
) {

    this.initialize = (fileUploader: JS5Object) => {
        // Service is created & registered before AuthFactory is created
        let AuthFactory = $injector.get('AuthFactory');
        fileUploader.url = EndPointService.fileUploadEndPoint;
        fileUploader.alias = 'multipart-content';
        fileUploader.autoUpload = false;
        fileUploader.formData = {};
        fileUploader.headers = {
            'Authorization': AuthFactory.getAuthHeader(),
            'Accept': 'application/json, text/plain, */*'
        };
    };

    this.uploadFileToTemp = (fileUploader: JS5Object, origFileItem: JS5Object, origIndex: number, origUploadInfo: JS5Object, targetSubdirectory: string, targetPackageId: string) => {
        if (fileUploader.url !== EndPointService.fileUploadEndPoint) {
            throw 'fileUploader must be initialized before upload!';
        }
        if (origIndex !== 0) {
            return origUploadInfo.extraProps.nativeTempDeferredFileUpload.promise;
        }
        // Upload all fileItems at once
        origUploadInfo.extraProps.allUploadInfos.forEach((currUploadInfo: JS5Object) => {
            currUploadInfo.extraProps.nativeTempDeferredFileUpload = $q.defer();
        });

        fileUploader.onProgressItem = (currFileItem: JS5Object, progress: number) => {
            let currUploadInfo = origUploadInfo.extraProps.findUploadInfoForFileItem(currFileItem);
            currUploadInfo.progressObservable.onNext(progress/100);
        }
        fileUploader.onSuccessItem = (currFileItem: JS5Object, response: JS5Object) => {
            let currUploadInfo = origUploadInfo.extraProps.findUploadInfoForFileItem(currFileItem);
            currUploadInfo.extraProps.deferredVirtualPath.resolve(response.path);
            currUploadInfo.extraProps.nativeTempDeferredFileUpload.resolve(response);
        };
        fileUploader.onErrorItem = (currFileItem: JS5Object, response: JS5Object, status: string, headers: JS5Object) => {
            let currUploadInfo = origUploadInfo.extraProps.findUploadInfoForFileItem(currFileItem);
            currUploadInfo.extraProps.nativeTempDeferredFileUpload.reject(response);
        };

        fileUploader.uploadAll();
        return origUploadInfo.extraProps.nativeTempDeferredFileUpload.promise;
    };

    this.cleanup = (fileUploader: JS5Object) => {
        // Nothing to cleanup
    };
});


//=================//
// Lifecycle Hooks //
//=================//

// Load this service when app is initialized
angular.module('prism-ui.components').run((
    NativeTempFileUploadService: JS5Object,
    TempFileUploadService: JS5Object,
) => {
    TempFileUploadService.registerTempFileUploadServiceImplementation('NATIVE', NativeTempFileUploadService);
});
